/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
// import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import produce from 'immer';
import Draggable from 'react-draggable';
import { useForm } from 'react-hook-form';
import { shallowEqual, useSelector } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { toast } from 'react-toastify';

import { DefaultButton, PrimaryButton, Spinner, SpinnerSize, } from '@fluentui/react';
// import { v4 as uuid_v4 } from "uuid";
// import numeral from "numeral";
// import Dropzone from 'react-dropzone';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { AttachmentPreview } from '@partialcomponents/AttachmentPreview';
import { useQueryClient } from '@tanstack/react-query';

import { ARCHEM_MAIN_KEYS, useDigitalSignatureMutation, useGetSignatureSettings } from '../_useApiMain';
// import { AttachmentPreview } from '../../_metronic/_partials/controls/AttachmentPreview';
// import UploadFileService from './ComposeEmail/UploadFileService';
import UploadService from '../ComposeEmail/UploadFileService';

// import schema from './DigitalSignatureSchema';
// import { DigitalSignatureSettingsPreview } from './DigitalSignatureSettingsPreview';
// import { QueryCache, QueryClient, Query ClientProvider } from '@tanstack/react-query';

const ARCHEM_URL = process.env.REACT_APP_API_URL + "purchasing/";
function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export function DigitalSignature({
  isHidden,
  toggleSignatureDialog,
  file,
  onAttachmentError
}) {

  const defaultValues = {
    po_top_cell: 'E86', po_bottom_cell: '', po_stretch: false,
    so_top_cell: 'H', so_bottom_cell: '', so_stretch: false
  };

  const { trigger, getValues, clearErrors, reset, formState: { isValid } } = useForm({ mode: 'all', defaultValues: defaultValues });

  // const properties = { errors, schema, clearErrors, control, getValues, setValue, trigger, };

  const [isSaving, setIsSaving] = useState(false);
  const [currentFile, setCurrentFile] = useState(null);
  // const [isStretch, setIsStretch] = useState(false);
  const queryClient = useQueryClient();

  const _apiSignature = useDigitalSignatureMutation();

  useEffect(() => {
    setCurrentFile(null);
  }, []);

  useEffect(() => {
    // console.log(files);
    if (file) {
      setCurrentFile(file);
    }
  }, [file]);

  const { currentUser } = useSelector((state) => ({
    currentUser: state.auth.user,
  }), shallowEqual);

  // const [pdfURL, setPdfURL] = useState('');
  // const [soPdfURL, setSoPdfURL] = useState('');
  // const _apiPreviewPO = usePreviewSignatures(currentUser?.user.username, isHidden, 'purchaseorder');
  // const _apiPreviewSO = usePreviewSignatures(currentUser?.user.username, isHidden, 'salesorder');
  const _apiSettings = useGetSignatureSettings(currentUser?.user.username, isHidden);

  // useEffect(() => {
  //   if (_apiPreviewPO.data) {
  //     const file = new Blob([_apiPreviewPO.data], {
  //       type: "application/pdf"
  //     });
  //     const fileURL = URL.createObjectURL(file);
  //     setPdfURL(fileURL);
  //   }
  // }, [_apiPreviewPO.data]);

  // useEffect(() => {
  //   if (_apiPreviewSO.data) {
  //     const file = new Blob([_apiPreviewSO.data], {
  //       type: "application/pdf"
  //     });
  //     const fileURL = URL.createObjectURL(file);
  //     setSoPdfURL(fileURL);
  //   }
  // }, [_apiPreviewSO.data]);

  // useEffect(() => {
  //   if (_apiPreviewPO.error) {
  //     async function CheckError(error) {

  //       let err = error.response?.data;
  //       if (
  //         error.request.responseType === 'blob' &&
  //         error.response?.data instanceof Blob &&
  //         error.response?.data?.type &&
  //         error.response?.data?.type.toLowerCase().indexOf('json') !== -1
  //       ) {
  //         err = JSON.parse(await error.response.data.text()).error;
  //       }
  //       console.log(err);
  //     }

  //     CheckError(_apiPreviewPO.error);
  //   }
  // }, [_apiPreviewPO.error]);



  useEffect(() => {
    if (_apiSettings.data) {
      const { po, so } = _apiSettings.data;
      reset({
        po_top_cell: po?.top_cell || 'E86', po_bottom_cell: po?.bottom_cell || '', po_stretch: po?.is_stretch || false,
        so_top_cell: so?.top_cell || 'E86', so_bottom_cell: so?.bottom_cell || '', so_stretch: so?.is_stretch || false,
      });
    }
  }, [_apiSettings.data, reset]);

  const [signatureURL, setSignatureURL] = useState('');

  useEffect(() => {
    if (currentUser && !isHidden) {
      axios(ARCHEM_URL + 'getsignature?user=' + currentUser.user.username, {
        method: "GET",
        responseType: "blob"
        //Force to receive data in a Blob Format
      })
        .then(response => {
          const file = new Blob([response.data]);

          const fileURL = URL.createObjectURL(file);
          setSignatureURL(fileURL);
        })
        .catch(error => {
          console.log(error);
        });

      queryClient.invalidateQueries(ARCHEM_MAIN_KEYS.previewSignature(currentUser.user.username, isHidden));
      // previewPDF();
    }
  }, [currentUser, isHidden]);

  const handleRemove = (file) => {
    // setCurrentUploadingFile(produce((draft) => { return draft.filter(f => f.new_file_uid !== file.new_file_uid) }));        
  };

  const uploadAttachment = (currentFile, data) => {

    let _d = Object.assign({}, data);
    _d.currentuser = currentUser.user.username;
    setIsSaving(true);
    UploadService.upload(currentFile, _d, 'signature', (event) => {
      setCurrentFile(produce((draft) => {
        draft.percent = Math.round((100 * event.loaded) / event.total);
      }));
    })
      .then((response) => {
        console.log(response);
        setCurrentFile(produce((draft) => {
          draft.percent = 0;
        }));

        saveSignatureSettings();
      })
      .catch((e) => {
        setIsSaving(false);
        handleRemove(data);
        console.log(e);
      });
  }

  const saveSignatureSettings = async () => {
    await trigger();
    if (!isValid) { return; }

    let _data = getValues();
    _data.stretch = false; // isStretch;
    _data.user = currentUser.user.username;

    _apiSignature.mutate(_data, {
      onSuccess: (d) => {
        toast.success("New digital signature successfully saved.");
        setIsSaving(false);
        // queryClient.invalidateQueries(ARCHEM_MAIN_KEYS.previewSignature, { exact: false }); 
        queryClient.invalidateQueries(ARCHEM_MAIN_KEYS.previewSignature(currentUser.user.username, isHidden, 'purchaseorder'), { exact: false });
        queryClient.invalidateQueries(ARCHEM_MAIN_KEYS.previewSignature(currentUser.user.username, isHidden, 'salesorder'), { exact: false });
        toggleSignatureDialog();
        // previewPDF();
        // toggleSignatureDialog();
      },
      onError: (e) => {
        toast.error('Error encountered.');
        console.log(e);
        setIsSaving(false);
      }
    })
  }

  const onAttachmentChange = ({ file, fileData }) => {
    setCurrentFile({ file, fileData });
  }

  const onSave = () => {
    if (currentFile) {
      uploadAttachment(currentFile.fileData, currentFile.file)

    } else {
      saveSignatureSettings();
      // toast.info('No changes to signature made. Please upload a new digital signature first.');
    }
  }

  // const onChangeStretch = (checked) => {
  //   setIsStretch(!!checked);
  // }

  return (<>

    <Dialog open={!isHidden} maxWidth="md" fullWidth
      PaperComponent={PaperComponent}
      aria-labelledby="confirm-dialog-draggable"
    >
      <DialogTitle style={{ cursor: 'move' }} id="confirm-dialog-draggable" className="title-underline">Change Digital Signature</DialogTitle>
      <DialogContent style={{ overflowY: 'unset' }}>
        <Tabs forceRenderTabPanel
        // onSelect={(index) => { 
        //     if (index === 6) {
        //         setTimeout(() => { rteOtherTerms.refreshUI(); }, 200);                                
        //     } else if (index === 7) {
        //         setTimeout(() => { rteDocumentsRequired.refreshUI(); }, 200); 
        //     }
        // }}
        >
          <TabList style={{ minWidth: 180 }}>
            <Tab selectedClassName="react-tabs__tab--selected tab_selected_blue">Digital Signature</Tab>
            {/* <Tab selectedClassName="react-tabs__tab--selected tab_selected_blue">Purchase Order</Tab>
            <Tab selectedClassName="react-tabs__tab--selected tab_selected_blue">Sales Order</Tab> */}
          </TabList>

          <TabPanel>
            <AttachmentPreview uploadType="signature" onAttachmentChange={onAttachmentChange} signatureURL={signatureURL} />
          </TabPanel>

          {/* <TabPanel>
            <DigitalSignatureSettingsPreview
              properties={properties}
              onChangeStretch={onChangeStretch}
              isStretch={_apiSettings.data?.po?.is_stretch}
              pdfURL={pdfURL}
              isPreviewLoading={_apiPreviewPO.isLoading || _apiPreviewPO.isRefetching}
              idBottomCell="po_bottom_cell"
              idStretch="po_stretch"
              idTopCell="po_top_cell"
              setValue={setValue}
            />
          </TabPanel>

          <TabPanel>
            <DigitalSignatureSettingsPreview
              properties={properties}
              onChangeStretch={onChangeStretch}
              pdfURL={soPdfURL}
              isPreviewLoading={_apiPreviewSO.isLoading || _apiPreviewSO.isRefetching}
              idBottomCell="so_bottom_cell"
              idStretch="so_stretch"
              idTopCell="so_top_cell"
              isStretch={_apiSettings.data?.so?.is_stretch}
              setValue={setValue}
            />
          </TabPanel> */}
        </Tabs>

      </DialogContent>

      <DialogActions>
        <PrimaryButton onClick={onSave} text="Save" disabled={isSaving}>
          {isSaving && <Spinner size={SpinnerSize.xSmall} />}
        </PrimaryButton>
        <DefaultButton onClick={() => { reset(defaultValues); clearErrors(); toggleSignatureDialog(); }} text="Cancel" />

      </DialogActions>
    </Dialog>

  </>)
}